import type { FC } from 'react'
import React from 'react'

import NumberBadge from '@vfuk/core-number-badge'

import type { IconBundlesProps } from './IconBundles.types'
import * as Styled from './styles/IconBundles.style'

import { nonThemeableRules } from '../../ruleSet'

const IconBundles: FC<IconBundlesProps> = ({
  size = nonThemeableRules.defaultSize as number as IconBundlesProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
  numberBadge,
}: IconBundlesProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
        <g fill='none'>
          <path
            d='M12.05 12.852v7.66M4.535 13.75v2.32c0 .68.395 1.301 1.008 1.59l5.707 2.695a1.74 1.74 0 0 0 1.5 0l5.7-2.699a1.754 1.754 0 0 0 1.007-1.59v-2.355'
            vectorEffect='non-scaling-stroke'
          />
          <path
            d='M4.535 9.32 3.06 11.535a1.101 1.101 0 0 0 .445 1.606l5.465 2.578c.492.23 1.082.066 1.386-.39l1.692-2.485Zm10.515 6.399 5.45-2.574c.55-.258.785-.915.523-1.465-.023-.047-.046-.098-.078-.14l-1.484-2.216-7.414 3.524 1.617 2.488c.305.45.895.613 1.387.383ZM4.535 9.316l7.59-3.578-1.328-1.265A2.062 2.062 0 0 0 8.48 4.09L3.992 6.203a1.3 1.3 0 0 0-.422 2.031l.957 1.082Zm0 0'
            vectorEffect='non-scaling-stroke'
          />
          <path
            d='m19.469 9.316 1-1.101a1.295 1.295 0 0 0-.395-2.035l-4.273-2.075a2.064 2.064 0 0 0-2.32.352l-1.364 1.277Zm0 0'
            vectorEffect='non-scaling-stroke'
          />
        </g>
      </svg>
      <If condition={numberBadge}>
        <Styled.NumberBadgeContainer>
          <NumberBadge number={numberBadge!} appearance={inverse ? appearance : 'primary'} />
        </Styled.NumberBadgeContainer>
      </If>
    </Styled.IconWrapper>
  )
}

export default IconBundles
